import React, { useState } from 'react';
import './App.css';
import Login from './components/auth/Login';
import DebugComponent from './components/DebugComponent';
import Dashboard from './pages/Dashboard';
// import Layout from './components/layout/Layout';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <div className="App">
     
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <div className="dashboard-container">
          <Dashboard user={user} onLogout={handleLogout} />
        </div>
      )}
    </div>
  );
}

export default App;
